import React from "react";
import "./HowItWorks.css";

const HowItWorks = () => {
  const cardData = [
    {
      title: "Affordable Pricing, No Hidden Fees",
      description:
        "Skip traditional valuations costing $10,000+. Get a professional valuation report starting at $109 — 90% cheaper than industry standards.",
      icon: <img src="/assets/images/HowItWorks/Vector.png" alt="↗" />,
    },
    {
      title: "24-Hour Valuation Report",
      description:
        "Submit details via our user-friendly valuation dashboard and receive insights within a day.",
      icon: <img src="/assets/images/HowItWorks/Vector.png" alt="↗" />,
    },
    {
      title: "Expert-Curated Insights",
      description:
        "Combining AI-driven algorithms and human expertise , we deliver customized valuation reports for fundraising, M&A, or strategic decisions.",
      icon: <img src="/assets/images/HowItWorks/Vector.png" alt="↗" />,
    },
  ];
  return (
    <>
      <section className="how-it-works">
        <div className="how-it-works-container">
          <h4 className="subtitle">How It Works</h4>
          <h2 className="title">
            Fast & Transparent Online Business Valuation Tool
          </h2>
          <p className="description">
            From data input to precise valuation results , Clybourne’s platform
            streamlines the process for startups and established businesses
            alike.
          </p>
        </div>
      </section>
      <section className="card-section">
        <div className="card-container">
          {cardData.map((card, index) => (
            <div className="card-hiw" key={index}>
              <div className="card-icon">{card.icon}</div>
              <h3 className="card-title">{card.title}</h3>
              <p className="card-description">{card.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default HowItWorks;
